import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function CollectionProperties() {
  const [CollectionProperties, setCollectionProperties] = useState({});

  useEffect(() => {
    const fetchCollectionProperties = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/collection/properties-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCollectionProperties(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCollectionProperties();
  }, []);

  return (
    <div className="home-projects-sec">
      <Container fluid>
        <div className="home-projects-sec-div">
          <Row className="banner-text-center">
            <Col md={7}>
              <div className="project-img-card" data-aos="fade-right">
                <Link
                  to={`/properties${CollectionProperties.large_project_card_link}`}
                >
                  <img
                    src={`${apiUrl.apiUrl}/${CollectionProperties.large_project_card_image}`}
                    className="img-fluid"
                    alt="Premium properties Dubai"
                  />
                  <div className="project-img-desc">
                    <h3 className="goldenColor luxury-font">
                      {CollectionProperties.large_project_card_title}
                    </h3>
                    <p>
                      {CollectionProperties.large_project_card_description}
                    </p>
                  </div>
                </Link>
              </div>
            </Col>
            <Col md={4}>
              <div className="project-img-sm-card" data-aos="fade-left">
                <Link
                  to={`/properties${CollectionProperties.first_small_project_card_link}`}
                >
                  <img
                    src={`${apiUrl.apiUrl}/${CollectionProperties.first_small_project_card_image}`}
                    className="img-fluid"
                    alt="Luxury real estate Developer Dubai"
                  />

                  <div className="project-img-desc">
                    <h3 className="goldenColor luxury-font">
                      {CollectionProperties.first_small_project_card_title}
                    </h3>
                    <p>
                      {
                        CollectionProperties.first_small_project_card_description
                      }
                    </p>
                  </div>
                </Link>
              </div>
              <div className="project-img-sm-card" data-aos="fade-left">
                <Link
                  to={`/properties${CollectionProperties.second_small_project_card_link}`}
                >
                  <img
                    src={`${apiUrl.apiUrl}/${CollectionProperties.second_small_project_card_image}`}
                    className="img-fluid"
                    alt="Luxury apartments for sale in dubai"
                  />

                  <div className="project-img-desc">
                    <h3 className="goldenColor luxury-font">
                      {CollectionProperties.second_small_project_card_title}
                    </h3>
                    <p>
                      {" "}
                      {
                        CollectionProperties.second_small_project_card_description
                      }
                    </p>
                  </div>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default CollectionProperties;
